export const downloadUrl = (url, filename) => {
  const ie11ForceDownload = true;
  if (
    ie11ForceDownload &&
    navigator.msSaveOrOpenBlob &&
    !/Edge/.test(navigator.userAgent)
  ) {
    const xhr = new XMLHttpRequest();
    xhr.open("GET", url, true);
    xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");
    xhr.responseType = "blob";
    xhr.onload = () => {
      if (this.status === 200)
        navigator.msSaveOrOpenBlob(this.response, filename);
    };
    xhr.send();
    return;
  }
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  a.remove();
};

export const downloadBlob = (blob, filename) => {
  if (navigator.msSaveOrOpenBlob) {
    navigator.msSaveOrOpenBlob(blob, filename);
  } else {
    const url = URL.createObjectURL(blob);
    downloadUrl(url, filename);
    URL.revokeObjectURL(url);
  }
};
